<template>
  <div>
    <signup-component />
  </div>
</template>

<script>
import SignupComponent from '@/components/SignupComponent.vue';
export default {
  name: "SignupPage",
  components: { SignupComponent },
};
</script>

<style scoped>
</style>

